<script setup lang="ts">
import { NSwitch } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  value?: boolean
  defaultValue?: boolean
  size?: 'small' | 'medium' | 'large'
  disabled?: boolean
  loading?: boolean
  round?: boolean
  railStyle?: any
  nodeStyle?: any
  checkedValue?: any
  uncheckedValue?: any
  onUpdateValue?: (value: boolean) => void
  onChange?: (value: boolean) => void
}>(), {
  value: undefined,
  defaultValue: false,
  size: 'medium',
  disabled: false,
  loading: false,
  round: true,
  railStyle: undefined,
  nodeStyle: undefined,
  checkedValue: true,
  uncheckedValue: false,
})

const emit = defineEmits<{
  'update:value': [value: boolean]
  'change': [value: boolean]
}>()

const attrs = useAttrs()

const onUpdateValue = (value: boolean) => {
  emit('update:value', value)
}

const onChange = (value: boolean) => {
  emit('change', value)
}
</script>

<template>
  <NSwitch
    :value="value"
    :default-value="defaultValue"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :round="round"
    :rail-style="railStyle"
    :node-style="nodeStyle"
    :checked-value="checkedValue"
    :unchecked-value="uncheckedValue"
    v-bind="attrs"
    @update:value="onUpdateValue"
    @change="onChange"
  />
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
